import { render, staticRenderFns } from "./HandicapReplenData.vue?vue&type=template&id=12228fde&scoped=true"
import script from "./HandicapReplenData.vue?vue&type=script&lang=js"
export * from "./HandicapReplenData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12228fde",
  null
  
)

export default component.exports